import { Button, Stack, Typography, alpha, styled } from '@mui/material';
import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { PostHog } from 'src/services/analytics/posthog';
import { Sentry } from 'src/services/sentry';
import { Iconify } from '../iconify';
import Logo from '../logo';

const isDev =
  location.hostname === 'localhost' || location.hostname === 'dev.copera.ai';

export const UncaughtError = ({ error, resetErrorBoundary }: FallbackProps) => {
  const message =
    error?.response?.data?.message ||
    (isDev ? error?.message : 'Oops! An error occurred');

  useEffect(() => {
    Sentry.captureError(error);
    PostHog.capture('uncaught_error', { error: error.message });
    console.error(error);
  }, [error]);

  return (
    <StyledErrorCard>
      <Logo disabledLink />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {message}
      </Typography>

      <Button
        onClick={() => resetErrorBoundary()}
        variant="contained"
        color="secondary"
        startIcon={<Iconify icon="tabler:refresh" />}
      >
        Refresh
      </Button>

      <Typography variant="body2" color="text.secondary">
        If the problem persists, please contact support.
      </Typography>
    </StyledErrorCard>
  );
};

const StyledErrorCard = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  padding: theme.spacing(4, 8),
  margin: `${theme.spacing(4)} auto`,
  border: `1px solid ${alpha(theme.palette.error.main, 0.48)}`,
  borderRadius: theme.spacing(1),
  // boxShadow: theme.customShadows.error,
  backgroundColor: alpha(theme.palette.error.main, 0.04),
  width: 'fit-content',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));
